

































/* eslint-disable class-methods-use-this */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import SymbolStyleDefinition from '@/components/layers/style/SymbolStyleDefinition.vue';
import LayerConfig from '@/models/map-context/LayerConfig';
import LayerStyle from '@/models/map-context/LayerStyle';
import SymbolStyle from '@/models/map-context/style/SymbolStyle';
import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  props: {
    layerStyle: LayerStyle,
    layer: LayerConfig,
    is3DView: Boolean,
  },
  components: {
    SymbolStyleDefinition,
  },
})
export default class PointStyleDefinition extends Vue {
  layerStyle!: LayerStyle;

  layer!:LayerConfig;

  visible = false;

  pointSymbolType = '';

  mounted() {
    this.pointSymbolType = this.layerStyle.getPointSymbolType() || '';
  }

  pointSymbolTypeList = [{
    item: 'circle', name: 'cercle', is3d: true, isonly3d: false,
  },
  {
    item: 'square', name: 'carré', is3d: true, isonly3d: false,
  },
  {
    item: 'cross', name: 'croix', is3d: true, isonly3d: false,
  },
  {
    item: 'triangle', name: 'triangle', is3d: true, isonly3d: false,
  },
  {
    item: 'star', name: 'étoile', is3d: true, isonly3d: false,
  },
  {
    item: 'svg', name: 'svg', is3d: true, isonly3d: false,
  },
  ];

  onChangeType(event: string) {
    this.pointSymbolType = event;
    this.layerStyle.pointSymbolType = event;
    if (event === 'svg') {
      const prev = this.layerStyle.pointSymbol;
      const next = new SymbolStyle();
      // Conserver taille / couleurs de la classification lors du passage en SVG
      if (prev) {
        next.size = prev.size;
        next.offsetZ = prev.offsetZ;
        next.halo = prev.halo;
        next.symbolFillColor = prev.symbolFillColor
          || this.layerStyle.fillStyle.fillColor;
        next.symbolStrokeColor = prev.symbolStrokeColor
          || this.layerStyle.strokeStyle.color;
        next.symbolStrokeWidth = prev.symbolStrokeWidth;
        next.haloSymbolFillColor = prev.haloSymbolFillColor;
        next.haloSymbolStrokeColor = prev.haloSymbolStrokeColor;
        next.haloSymbolStrokeWidth = prev.haloSymbolStrokeWidth;
      }
      this.layerStyle.pointSymbol = next;
    }
    this.inputChange();
  }

  inputChange() {
    this.$emit('symboChange', '');
  }
}
